webpackJsonp([209186522583587],{

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _flagicon = __webpack_require__(45);
	
	var _flagicon2 = _interopRequireDefault(_flagicon);
	
	var _reactstrap = __webpack_require__(65);
	
	var _countries = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var worldjson = __webpack_require__(60);
	
	var GroupF = function GroupF(props) {
	  var groups = props.data.allThirdPartyWorldCupGroups.edges;
	
	  function searchCountryName(code) {
	    if (code == ('gb' || 'GB')) {
	      return 'England';
	    }
	    for (var i = 0; i < worldjson.length; i++) {
	      if (worldjson[i].cca2 == code) {
	        return worldjson[i].translations.deu.common;
	      }
	    }
	  }
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Gruppen'
	    ),
	    groups.map(function (group, i) {
	      var groupData = group;
	      console.log(groupData);
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Gruppe ',
	          groupData.node.letter
	        ),
	        _react2.default.createElement(
	          _reactstrap.Table,
	          { striped: true },
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'th',
	              null,
	              '#'
	            ),
	            _react2.default.createElement(
	              'th',
	              null,
	              'Land'
	            ),
	            _react2.default.createElement(
	              'th',
	              null,
	              'Pkt.'
	            ),
	            _react2.default.createElement(
	              'th',
	              null,
	              'TDiff.'
	            )
	          ),
	          groupData.node.ordered_teams.map(function (teams, i) {
	            return _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'td',
	                null,
	                i + 1
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                _react2.default.createElement(_flagicon2.default, { code: (0, _countries.findCountry)(teams.fifa_code) }),
	                ' ',
	                searchCountryName((0, _countries.findCountryUpper)(teams.fifa_code))
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                teams.points
	              ),
	              _react2.default.createElement(
	                'td',
	                null,
	                teams.goal_differential
	              )
	            );
	          })
	        )
	      );
	    })
	  );
	};
	
	exports.default = GroupF;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-groups-js-2f945123224adefca7c5.js